/* Größen-Tabelle auf der PDP (Handoff PDP-Kaufspalte §9).
   Hält die Zeilen aktuell, wenn sich die gewählte Variante ändert — auch bei
   mehrachsigen Produkten, wo ein Farbwechsel andere Preise je Größe bedeutet.

   Einstiegspunkt ist das bubbelnde `change` auf `input[name="id"]`, das Pinnacles
   variant-selects in updateVariantInput() bei jedem Variantenwechsel feuert.
   Damit hängt hier nichts an Theme-Interna außer diesem einen Event. */
(function () {
  'use strict';

  function parseData(fieldset) {
    var el = fieldset.querySelector('script[type="application/json"][data-pst-data]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function findVariant(variants, id) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) return variants[i];
    }
    return null;
  }

  /* Zeilen-Variante: gleicher Wert auf der Tabellen-Achse, übrige Achsen wie aktuell */
  function rowVariant(variants, axis, value, current) {
    var fallback = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options[axis] !== value) continue;
      if (!fallback) fallback = v;
      if (!current) return v;
      var match = true;
      for (var a = 0; a < v.options.length; a++) {
        if (a === axis) continue;
        if (v.options[a] !== current.options[a]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return fallback;
  }

  function setText(el, text) {
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('pst-is-empty', !text);
  }

  function stockFor(variant, threshold) {
    if (!variant || !variant.available) return { text: 'Nicht lieferbar', cls: 'pst-stock pst-stock--out' };
    if (variant.qty !== null && variant.qty > 0 && variant.qty <= threshold) {
      return { text: '● Nur noch ' + variant.qty + ' auf Lager', cls: 'pst-stock pst-stock--low' };
    }
    return { text: '● Auf Lager', cls: 'pst-stock' };
  }

  function refresh(fieldset, variantId) {
    var data = fieldset.__pstData || (fieldset.__pstData = parseData(fieldset));
    if (!data) return;
    var current = findVariant(data.variants, variantId);

    fieldset.querySelectorAll('[data-pst-row]').forEach(function (row) {
      var variant = rowVariant(data.variants, data.axis, row.dataset.pstValue, current);
      if (!variant) return;

      var stock = stockFor(variant, data.lowThreshold);
      var stockEl = row.querySelector('[data-pst-stock]');
      if (stockEl) {
        stockEl.textContent = stock.text;
        stockEl.className = stock.cls;
      }

      setText(row.querySelector('[data-pst-price]'), variant.price);
      setText(row.querySelector('[data-pst-compare]'), variant.compare);
      setText(row.querySelector('[data-pst-unit]'), variant.unit);
      setText(row.querySelector('[data-pst-badge]'), variant.pct >= 3 ? '−' + variant.pct + ' %' : '');

      if (variant.available) {
        row.removeAttribute('aria-disabled');
      } else {
        row.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function refreshAll(variantId) {
    document.querySelectorAll('fieldset.pst').forEach(function (fieldset) {
      refresh(fieldset, variantId);
    });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || target.tagName !== 'INPUT' || target.name !== 'id') return;
    var id = parseInt(target.value, 10);
    if (id) refreshAll(id);
  });

  /* Ausverkaufte Zeilen bleiben sichtbar und fokussierbar, lassen sich aber
     nicht auswählen (aria-disabled statt disabled, §10). */
  document.addEventListener(
    'click',
    function (event) {
      var row = event.target.closest && event.target.closest('.pst-row[aria-disabled="true"]');
      if (!row) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );
})();
